import { useGlobals } from 'hooks/useGlobals';
import { STUDIES } from 'lib/constants/routes';
import { SciencePageId } from 'types/cms/science/SciencePageId';

import { ResultLayout } from '../layouts/ResultLayout';
import type { NavigationPayload } from '../SearchResults';

interface StudiesProps {
  onNavigate: ({ title, path }: NavigationPayload) => void;
}

const title = 'Our studies';

export function Studies({ onNavigate }: StudiesProps) {
  const { data: globals } = useGlobals();
  const path = STUDIES;

  const navigationCards = globals?.siteSettings.scienceNav?.navigationCards;
  const studiesCard = navigationCards?.find(
    (card) => card.link._id === SciencePageId.STUDIES,
  );

  return (
    <ResultLayout
      href={path}
      title={title}
      image={studiesCard?.image}
      onNavigate={() => onNavigate({ title, path })}
      type="Science"
    />
  );
}
